<template>
  <div class="container">
    <template v-if="!showUploadingMessage">
      <!-- CTA: NONE -->
      <template v-if="checkin.user_cta === userCTA.NONE && !hasBoughtOrHasBuyable">
        <template v-if="!eventClosed">
          <template v-if="eventIsStarted">
            <CtaNoPhotosInStay :event-name="eventName" :pica-code="picaCode"
                               :can-purchase-during-stay="canPurchaseDuringStay"
                               v-if="isBoolean(canPurchaseDuringStay)"/>
            <CtaSupport :event-name="eventName" :pica-code="picaCode" v-else/>
          </template>
          <CtaIncomingEvent :event-name="eventName" :pica-code="picaCode" v-else/>
        </template>
        <CtaSupport :event-name="eventName" :pica-code="picaCode" v-else/>
      </template>

      <!-- CTA: SUPPORT -->
      <CtaSupport :event-name="eventName"
                  :pica-code="picaCode"
                  v-else-if="checkin.user_cta === userCTA.SUPPORT"/>

      <!-- CTA: FACE_CHECKIN -->
      <CtaFaceCheckin :event-name="eventName"
                      :pica-code="picaCode"
                      v-else-if="checkin.user_cta === userCTA.FACE_CHECKIN && !hideUserCta"
                      @click="onFaceCheckinCta"/>
    </template>
    <CtaUploading :event-name="eventName" :pica-code="picaCode" v-else/>
  </div>
</template>


<script>
import {mapGetters} from "vuex";
import {userCTA} from "@/consts";
import CtaUploading from "@/domain/checkinDetail/cta/CtaUploading.vue";
import CtaFaceCheckin from "@/domain/checkinDetail/cta/CtaFaceCheckin.vue";
import CtaNoPhotosInStay from "@/domain/checkinDetail/cta/CtaNoPhotosInStay.vue";
import CtaIncomingEvent from "@/domain/checkinDetail/cta/CtaIncomingEvent.vue";
import CtaSupport from "@/domain/checkinDetail/cta/CtaSupport.vue";
import {isBoolean} from "lodash";

export default {
  name: "UserCtas",
  emits: ['face-checkin-cta'],
  components: {CtaSupport, CtaIncomingEvent, CtaNoPhotosInStay, CtaFaceCheckin, CtaUploading},
  props: {
    showUploadingMessage: {
      type: Boolean,
      default: false
    },
    hideUserCta: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('checkinDetail', [
      'checkin',
      'picaCode',
      'eventClosed',
      'hasBuyablePhotos',
      'hasBuyableVideos',
      'eventName',
      'hasBought',
      'canPurchaseDuringStay'
    ]),
    userCTA() {
      return userCTA
    },
    // TODO: Review this computed property
    hasBoughtOrHasBuyable() {
      return this.hasBuyablePhotos || this.hasBuyableVideos || this.hasBought
    },
    eventIsStarted() {
      return new Date() > new Date(this.checkin.pica_service.event_start_at)
    },
  },
  methods: {
    isBoolean,
    onFaceCheckinCta() {
      this.$emit('face-checkin-cta')
    }
  }
}
</script>


<style scoped>

</style>